import { useState, useCallback } from 'react';
import { HotspotData, HotspotFilterState } from '../types/hotspots';
import { HotspotsApiService } from '../services/hotspotsApi';
import { getTodayDateString, getDateNDaysAgo } from '../utils/hotspots';

export const useHotspots = () => {
    const [hotspots, setHotspots] = useState<HotspotData[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [filters, setFilters] = useState<HotspotFilterState>({
        start_date: getTodayDateString(),
        end_date: getTodayDateString(),
    });

    const fetchHotspots = useCallback(async (filterParams?: HotspotFilterState) => {
        setLoading(true);
        setError(null);

        try {
            const filtersToUse = filterParams || filters;
            const response = await HotspotsApiService.getHotspots(filtersToUse);
            setHotspots(response.data);
            return response.data;
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Failed to fetch hotspots';
            setError(errorMessage);
            console.error('Error fetching hotspots:', err);
            return [];
        } finally {
            setLoading(false);
        }
    }, [filters]);

    const updateFilters = useCallback((newFilters: HotspotFilterState) => {
        setFilters(newFilters);
    }, []);

    const clearFilters = useCallback(() => {
        const clearedFilters = {
            start_date: getTodayDateString(),
            end_date: getTodayDateString(),
        };
        setFilters(clearedFilters);
        return clearedFilters;
    }, []);

    return {
        hotspots,
        loading,
        error,
        filters,
        fetchHotspots,
        updateFilters,
        clearFilters,
    };
};
